<script lang="ts">
    import { Router, Route } from "svelte-navigator";
    import { SnackbarContainer } from "attractions";
    import App from "./App.svelte";
    import NotFound from "./NotFound.svelte";
</script>

<SnackbarContainer>
    <Router>
        <Route primary={false} path="/not-found">
            <NotFound />
        </Route>
        <Route primary={false} path="/*puzzleID" let:params>
            <App puzzleID={params.puzzleID} />
        </Route>
    </Router>
</SnackbarContainer>

<style lang="scss">
    :global(.snackbar-stack) {
        display: flex;
        flex-direction: column;
        position: fixed;
        left: 50%;
        bottom: 2rem;
        transform: translateX(-50%);
        z-index: 2000;
    }
</style>
